import ExpandableContainerController from './ExpandableContainerController';
import { registerExpandableContainerDirective } from './ExpandableContainerDirective';

export default function registerExpandableContainerComponent(angular) {
    angular.module('assessmentFrontendControllers').controller(
        'ExpandableContainerController',
        ['$scope', '$rootScope', '$config', ExpandableContainerController]
    );
    registerExpandableContainerDirective(angular.module('assessmentFrontendDirectives'));
}
